import axios from "axios";

let cachedToken = null;
let inFlightPromise = null;

/**
 * Obtém (ou atualiza) o token do Hasura.
 * - Cache simples em memória para evitar múltiplas chamadas concorrentes.
 * - Se force=true, ignora cache e refaz a requisição.
 */
export async function fetchHasuraToken(force = false) {
  if (!force && cachedToken) {
    return cachedToken;
  }
  if (inFlightPromise) {
    return inFlightPromise;
  }
  const url = `${process.env.REACT_APP_BACKEND}/auth/hasura-token`;
  const accessToken = localStorage.getItem('accessToken');
  inFlightPromise = axios
    .get(url, {
      withCredentials: true,
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
    })
    .then((response) => {
  // Resposta do token recebida (log detalhado removido)
      const data = response.data;
      const token = data?.hasuraToken || data?.token; // tolera ambos formatos
      if (!token) throw new Error("Resposta sem token (hasuraToken/token ausente)");
      cachedToken = token;
      return token;
    })
    .catch((err) => {
      return null
    })
    .finally(() => {
      inFlightPromise = null;
    });
  return inFlightPromise;
}

export function clearHasuraToken() {
  cachedToken = null;
}

export function getCachedHasuraToken() {
  return cachedToken;
}

export function decodeHasuraClaims(token = cachedToken) {
  if (!token || token.split('.').length !== 3) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    // Hasura claims podem estar em namespace customizado ou direto
    const hasuraClaims = payload['https://hasura.io/jwt/claims'] || payload;
    const userId = hasuraClaims['x-hasura-user-id'] || hasuraClaims['X-Hasura-User-Id'];
    return { userId, claims: hasuraClaims, raw: payload };
  } catch (e) {
    return null;
  }
}
